// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryPermissionAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var m = require('mobx');
  var observer = require('mobx-react').observer;
  var compose = require('recompose').compose;
  var withProps = require('recompose').withProps;
  var withHandlers = require('recompose').withHandlers;
  var setPropTypes = require('recompose').setPropTypes;
  var createTransformer = require('share/components/controls/CommonTree/Izenda.CommonTreeTransformer');
  var localizer = require('share/localization/Izenda.Localizer');
  const {
    flow,
    reject,
    forEach,
    invokeArgs,
    isEmpty,
    map,
    join,
    filter,
    get,
    negate,
    assign,
    find
  } = require('lodash/fp');
  var switchTree = function(fromNode, useFunction, toValue, props) {
    var recursiveSwitchState = m.action(
      flow(
        reject({ displayCheckedStatus: -1 }),
        forEach(function(node) {
          if (node.displayCheckedStatus === 1) {
            invokeArgs(useFunction, [toValue], node.basedNode);
          }
          node.checkboxStatus = false;
          recursiveSwitchState(node.displayChildNodes);
        })
      )
    );

    var displayNodes = filter('isDisplayNode', fromNode);
    if (useFunction === 'toggleSavable' && toValue) {
      validateSavable(displayNodes, props);
    }

    recursiveSwitchState(displayNodes);
    props.afterSwitchTree();
  };

  /**
   * Validate savable to show error message
   * @param  {Array} displayNodes
   * @param  {Object} props
   */
  function validateSavable(displayNodes, props) {
    var buildMessageCategory = function(node) {
      var displayChildNodes = isEmpty(node.displayChildNodes) ? '' : buildMessageCategories(node.displayChildNodes);
      return String.format('<li>{0}{1}</li>', node.basedNode.name, displayChildNodes);
    };

    var buildMessageCategories = flow(
      reject({ displayCheckedStatus: -1 }),
      map(buildMessageCategory),
      join(''),
      function(text) {
        return isEmpty(text) ? '' : String.format('<ul>{0}</ul>', text);
      }
    );

    var globalCategory = find(function(item) {
      return get('basedNode.isGlobal', item);
    }, displayNodes);

    if (globalCategory) {
      var globalNodes = get('displayChildNodes', globalCategory);
      var message = buildMessageCategories(globalNodes);
      var popupMessage = String.format(
        localizer.getText('ROLE_SETUP_PERMISSION_NOT_ALLOW_TO_SAVE'),
        props.typeName,
        message
      );

      if (message) {
        props.confirmFn('Information', {
          description: popupMessage,
          type: 'error',
          isHTMLFormat: true,
          showCloseIndicator: true
        });
      }
    }
  }

  var UserRolePermissionAction = compose(
    setPropTypes({
      categoryPermission: React.PropTypes.object.isRequired,
      rightHeader: React.PropTypes.string.isRequired,
      leftHeader: React.PropTypes.string.isRequired,
      middleHeader: React.PropTypes.string.isRequired
    }),
    withProps(function() {
      var leftTreeFilter = m.observable({ text: '' });
      var middleTreeFilter = m.observable({ text: '' });
      var rightTreeFilter = m.observable({ text: '' });
      var basedOption = {
        getChild: get('subCategories'),
        getText: get('name'),
        showNumChildren: get('showNumChildren'),
        getKey: get('displayKey'),
        checkBranchNode: negate(get('isSubCategory'))
      };

      var leftTreeOption = assign(basedOption, {
        checkDisplayNode: get('showInAvailableTree'),
        filter: leftTreeFilter
      });

      var middleTreeOption = assign(basedOption, {
        checkDisplayNode: get('showInVisibleTree'),
        filter: middleTreeFilter
      });

      var rightTreeOption = assign(basedOption, {
        checkDisplayNode: get('showInSavableTree'),
        filter: rightTreeFilter
      });

      return {
        leftTreeFilter: leftTreeFilter,
        transformerLeftTree: createTransformer(leftTreeOption),
        rightTreeFilter: rightTreeFilter,
        transformerRightTree: createTransformer(rightTreeOption),
        middleTreeFilter: middleTreeFilter,
        transformerMiddleTree: createTransformer(middleTreeOption)
      };
    }),
    observer,
    withProps(function(props) {
      var categories = props.categoryPermission.categories;

      return {
        leftTree: props.transformerLeftTree(categories),
        rightTree: props.transformerRightTree(categories),
        middleTree: props.transformerMiddleTree(categories)
      };
    }),
    withHandlers({
      fromLeftToMiddle: function(props) {
        return switchTree.bind(null, props.leftTree, 'toggleVisible', true, props);
      },
      fromMiddleToLeft: function(props) {
        return switchTree.bind(null, props.middleTree, 'toggleVisible', false, props);
      },
      fromRightToMiddle: function(props) {
        return switchTree.bind(null, props.rightTree, 'toggleSavable', false, props);
      },
      fromMiddleToRight: function(props) {
        return switchTree.bind(null, props.middleTree, 'toggleSavable', true, props);
      }
    })
  );

  module.exports = UserRolePermissionAction;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/PermissionBody/Izenda.CategoryPermissionAction.js